module.exports = __webpack_public_path__ + "img/logo.29449e96.svg";